module.exports = __webpack_public_path__ + "img/couple-dependant.3064b1b7.svg";